/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FundraiserDonation
 */
export interface FundraiserDonation {
    /**
     * 
     * @type {string}
     * @memberof FundraiserDonation
     */
    readonly organization_name: string;
    /**
     * 
     * @type {string}
     * @memberof FundraiserDonation
     */
    readonly fundraiser_name: string;
    /**
     * 
     * @type {string}
     * @memberof FundraiserDonation
     */
    readonly team_name: string;
    /**
     * 
     * @type {Date}
     * @memberof FundraiserDonation
     */
    readonly start_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof FundraiserDonation
     */
    readonly end_at: Date;
    /**
     * 
     * @type {string}
     * @memberof FundraiserDonation
     */
    readonly redemption_code: string;
}

/**
 * Check if a given object implements the FundraiserDonation interface.
 */
export function instanceOfFundraiserDonation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organization_name" in value;
    isInstance = isInstance && "fundraiser_name" in value;
    isInstance = isInstance && "team_name" in value;
    isInstance = isInstance && "start_at" in value;
    isInstance = isInstance && "end_at" in value;
    isInstance = isInstance && "redemption_code" in value;

    return isInstance;
}

export function FundraiserDonationFromJSON(json: any): FundraiserDonation {
    return FundraiserDonationFromJSONTyped(json, false);
}

export function FundraiserDonationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundraiserDonation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_name': json['organization_name'],
        'fundraiser_name': json['fundraiser_name'],
        'team_name': json['team_name'],
        'start_at': (new Date(json['start_at'])),
        'end_at': (new Date(json['end_at'])),
        'redemption_code': json['redemption_code'],
    };
}

export function FundraiserDonationToJSON(value?: FundraiserDonation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

